import { useState, useEffect, useCallback } from 'react';
import { fetchThreeWeekAuctions } from '../utils/api';

const REFRESH_INTERVAL_MS = 30 * 60 * 1000;

/**
 * Fetches three-week auction data and auto-refreshes every 30 minutes.
 * @param {number} [dbIndex] - 1-based database index.
 */
export function useThreeWeekCalendar(dbIndex) {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchThreeWeekAuctions(dbIndex);
      setAuctions(data);
      setLastRefresh(new Date());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [dbIndex]);

  useEffect(() => {
    load();
    const interval = setInterval(load, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [load]);

  return { auctions, loading, error, lastRefresh, refetch: load };
}
